// src/components/OfflineBanner.tsx

import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { useAppStore } from '../store/appStore';

/**
 * Displays a fixed warning banner when the app detects it is offline.
 * Automatically dismisses when connectivity is restored.
 * Uses CSS transitions for smooth show/hide animation.
 */
export function OfflineBanner() {
  useOnlineStatus();
  const isOffline = useAppStore((state) => state.isOffline);

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: '56px', // Below typical header height
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#f59e0b',
        color: '#1a1a1a',
        textAlign: 'center',
        padding: isOffline ? '12px 16px' : '0 16px',
        fontSize: '14px',
        fontWeight: 500,
        overflow: 'hidden',
        maxHeight: isOffline ? '60px' : '0',
        opacity: isOffline ? 1 : 0,
        transition: 'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease',
      }}
    >
      You are offline. Cached content is still available.
    </div>
  );
}
